var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('setting-content',{attrs:{"title":"Privacy Policy","settingKey":"privacyNoticeContent","lang":_vm.language}})}
var staticRenderFns = []

export { render, staticRenderFns }